// src/pages/OrderDetailsPage.js
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { formatDate } from '../utils/formatDate';
import PurchaseFormModal from "../components/PurchaseFormModal";
import "./OrderDetailsPage.css";
import PdfOptionsModal from "../components/PdfOptionsModal";
// Reużycie stylów karty podsumowania z OrderInfoModal
import "../components/OrderInfoModal.css";
import { API_URL } from "../config";
// Import ikon przycisków
import {
  confirmOff,
  confirmOn,
  buyOff,
  buyOn,
  followOff,
  followOn,
  validationOff,
  validationOn,
  editOff,
  editOn,
  pdfOff,
  pdfOn,
  logsOff,
  logsOn,
  meetOff,
  meetOn,
  deleteOff,
  deleteOn,
  // Nowe gify statusów
  oczekujace,
  przydzielone,
  realizowane,
  wstrzymane,
  walidacja,
  zatwierdzone,
  fakturowanie,
  zamkniete,
} from "../assets";
// Import nowego komponentu WorkTimeModal
import WorkTimeModal from "../components/WorkTimeModal";
// Import nowego komponentu OrderInfoModal
import OrderInfoModal from "../components/OrderInfoModal";
// Import nowego komponentu komentarzy zlecenia
import OrderCommentsSection from "../components/OrderCommentsSection";
// Import nowego komponentu materiałów zlecenia
import MaterialModal from "../components/MaterialModal";
// Import komponentu Czas Pracy Raportu 
import WorkTimeReportModal from "../components/WorkTimeReportModal";

// Funkcja zwracająca gif statusu na podstawie wartości statusu
function getStatusGif(status) {
  switch (status) {
    case "Oczekujące":
      return oczekujace;
    case "Przydzielone":
      return przydzielone;
    case "Realizowane":
      return realizowane;
    case "Wstrzymane":
      return wstrzymane;
    case "Walidacja":
      return walidacja;
    case "Zatwierdzone":
      return zatwierdzone;
    case "Fakturowanie":
      return fakturowanie;
    case "Zamknięte":
      return zamkniete;
    default:
      return null;
  }
}

// Komponent przycisku nowoczesnego – zmienia obrazek przy hover oraz wyświetla tooltip
function ModernActionButton({ name, onClick, tooltipText, disabled = false }) {
  const [hovered, setHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const timeoutRef = useRef();

  let imageSrc = "";
  if (name === "confirm") {
    imageSrc = hovered ? confirmOn : confirmOff;
  } else if (name === "buy") {
    imageSrc = hovered ? buyOn : buyOff;
  } else if (name === "follow") {
    imageSrc = hovered ? followOn : followOff;
  } else if (name === "validation") {
    imageSrc = hovered ? validationOn : validationOff;
  } else if (name === "edit") {
    imageSrc = hovered ? editOn : editOff;
  } else if (name === "pdf") {
    imageSrc = hovered ? pdfOn : pdfOff;
  } else if (name === "logs") {
    imageSrc = hovered ? logsOn : logsOff;
  } else if (name === "meet") {
    imageSrc = hovered ? meetOn : meetOff;
  } else if (name === "delete") {
    imageSrc = hovered ? deleteOn : deleteOff;
  }

  const handleMouseEnter = () => {
    setHovered(true);
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(true);
    }, 500);
  };

  const handleMouseLeave = () => {
    setHovered(false);
    clearTimeout(timeoutRef.current);
    setShowTooltip(false);
  };

  if (name === "save" || name === "cancel" || name === "advanced") {
    return (
      <div className="modern-action-button-wrapper" style={{ position: "relative", display: "inline-block" }}>
        <button
          className={`modern-action-button modern-text-button ${disabled ? "disabled" : ""}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={disabled ? undefined : onClick}
          disabled={disabled}
        >
          {name === "save" ? "Zapisz Zmiany" : name === "cancel" ? "Anuluj" : "Zaawansowane"}
        </button>
        {showTooltip && tooltipText && (
          <div className="action-tooltip">{tooltipText}</div>
        )}
      </div>
    );
  }

  return (
    <div className="modern-action-button-wrapper" style={{ position: "relative", display: "inline-block" }}>
      <button
        className={`modern-action-button ${disabled ? "disabled" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
      >
        <img src={imageSrc} alt={name} />
      </button>
      {showTooltip && tooltipText && (
        <div className="action-tooltip">{tooltipText}</div>
      )}
    </div>
  );
}

// Rozszerzony pasek przycisków – przyjmuje dodatkowe handlery
function ModernActionBar({
  order, // Dodaj ten prop
  isEditing,
  handleEditToggle,
  handleEditSubmit,
  handleEditCancel,
  handleDeleteClick,
  handleOpenOrderInfoModal,
  handleBuyClick,
  handleDownloadPDF,
  handleOpenAdvancedModal,
  currentUser,
  isWatching,
  onFollowClick,
}) {
  const hasEditPermissionLocal = () => {
    if (!currentUser) return false;
    if (currentUser.role === "Admin" || currentUser.role === "Moderator") return true;
    if (currentUser.id === order?.osoba_wprowadzajaca_id || currentUser.id === order?.osoba_wykonujaca_id) return true;
    return false;
  };

  if (isEditing && hasEditPermissionLocal()) {
    return (
      <div className="modern-action-bar">
        {currentUser.role === "Admin" && (
          <ModernActionButton name="advanced" onClick={handleOpenAdvancedModal} tooltipText="Zaawansowane ustawienia" />
        )}
        <ModernActionButton name="save" onClick={handleEditSubmit} tooltipText="Zapisz Zmiany" />
        <ModernActionButton name="cancel" onClick={handleEditCancel} tooltipText="Anuluj" />
      </div>
    );
  } else {
    return (
      <div className="modern-action-bar">
        <ModernActionButton name="confirm" onClick={() => {}} tooltipText="Zamknij Zlecenie" />
        <ModernActionButton name="buy" onClick={handleBuyClick} tooltipText="Zamów" />

        <ModernActionButton
          name="follow"
          onClick={onFollowClick}
          tooltipText={isWatching ? "Już obserwujesz" : "Obserwuj Zlecenie"}
          disabled={isWatching}
        />

        <ModernActionButton name="validation" onClick={handleOpenOrderInfoModal} tooltipText="Informacje o zleceniu" />
        <ModernActionButton name="edit" onClick={handleEditToggle} tooltipText="Edytuj Zlecenie" />
        <ModernActionButton name="pdf" onClick={handleDownloadPDF} tooltipText="Pobierz Raport PDF" />
        <ModernActionButton name="logs" onClick={() => {}} tooltipText="Historia Zlecenia" />
        <ModernActionButton name="meet" onClick={() => {}} tooltipText="Zaplanuj Spotkanie na temat Zlecenia" />
        <ModernActionButton name="delete" onClick={handleDeleteClick} tooltipText="Usuń Zlecenie" />
      </div>
    );
  }
}

function OrderDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Główne stany
  const [order, setOrder] = useState(null);
  const [materialSum, setMaterialSum] = useState(0);
  const [totalHours, setTotalHours] = useState(0); // <── brakujący stan
  const [workTimeSummary, setWorkTimeSummary] = useState({});
  const [materials, setMaterials] = useState([]);
  const [materialsLoading, setMaterialsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Tryb edycji
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    tytul: "",
    opis_zlecenia: "",
    waga: "",
    rodzaj_zgloszenia: "",
    obszar_id: "",
    klient_id: "",
    osoba_wykonujaca_id: "",
    status: "",
    deadline: "",
    stan_walidacji: false,
    osoba_walidujaca_id: "",
    nr_ref: "",
    osoba_wprowadzajaca_id: "",
    stan_archiwizacji: false,
    komentarz_zamkniecia: "",
    osoba_zlecajaca: "",
    nr_klienta: "",
  });

  /* jednorazowe mapowanie starych etykiet */
  const mapOrderType = (t) => {
    if (t === "Przegląd") return "Przegląd A";
    if (t === "Serwis") return "Przegląd Z";
    return t;
  };

  // Stan dla modalu "Zaawansowane"
  const [showAdvancedModal, setShowAdvancedModal] = useState(false);
  const [advancedData, setAdvancedData] = useState({
    stan_walidacji: false,
    stan_archiwizacji: false,
    komentarz_zamkniecia: "",
  });

  // Dropdowny w trybie edycji
  const [areas, setAreas] = useState([]);
  const [clients, setClients] = useState([]);
  const [workers, setWorkers] = useState([]);

  // Stany modali
  const [showStartModal, setShowStartModal] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [showConfirmValidationModal, setShowConfirmValidationModal] = useState(false);
  const [showRejectValidationModal, setShowRejectValidationModal] = useState(false);
  const [showCloseOrderModal, setShowCloseOrderModal] = useState(false);

  // Stany dla usuwania zlecenia
  const [deleteNotAllowedMessage, setDeleteNotAllowedMessage] = useState("");
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [showDeletePasswordModal, setShowDeletePasswordModal] = useState(false);
  const [deletePassword, setDeletePassword] = useState("");
  const [deleteError, setDeleteError] = useState("");

  // Stany dla walidacji
  const [selectedValidator, setSelectedValidator] = useState("");
  const [readyForValidation, setReadyForValidation] = useState(false);
  const [confirmValidationChecked, setConfirmValidationChecked] = useState(false);
  const [rejectValidationChecked, setRejectValidationChecked] = useState(false);

  // Stany dla zamykania zlecenia
  const [closeOrderComment, setCloseOrderComment] = useState("");

  // Dodany stan dla modalu formularza czasu pracy
  const [showWorkTimeModal, setShowWorkTimeModal] = useState(false);

  // Nowy stan dla modalu OrderInfoModal
  const [showOrderInfoModal, setShowOrderInfoModal] = useState(false);
  const [orderInfoInitialTab, setOrderInfoInitialTab] = useState('time'); // 'time' | 'material'

  const [showWorkTimeReportModal, setShowWorkTimeReportModal] = useState(false);

  // Nowy stan dla modalu materiałów
  const [showMaterialModal, setShowMaterialModal] = useState(false);

  // Nowy stan dla modalu zakupów
  const [showPurchaseFormModal, setShowPurchaseFormModal] = useState(false);

  // Nowy stan dla modalu PDF
  const [showPdfOptions, setShowPdfOptions] = useState(false);

  // Nowe stany dla opisu realizacji
  const [showOpisRealizacjiModal, setShowOpisRealizacjiModal] = useState(false);
  const [opisRealizacji, setOpisRealizacji] = useState("");

  // === WATCHERS: stany ===
  const [watchers, setWatchers] = useState([]);
  const [watchersLoading, setWatchersLoading] = useState(false);

  const [showAddWatcherModal, setShowAddWatcherModal] = useState(false);
  const [selectedWatcherId, setSelectedWatcherId] = useState("");

  // >>> DODANE: ref + auto-resize dla read-only „Opis Realizacji”
  const opisRealizacjiRef = useRef(null);
  useEffect(() => {
    if (opisRealizacjiRef.current) {
      const el = opisRealizacjiRef.current;
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  }, [opisRealizacji]);
  // <<< KONIEC DODANE

  const currentUser = JSON.parse(localStorage.getItem("user"));

  const isWatching =
    !!currentUser?.id &&
    watchers.some((w) => Number(w.user_id) === Number(currentUser.id));

  // === WATCHERS: funkcje API ===
  const fetchWatchers = async () => {
    if (!id) return;
    setWatchersLoading(true);
    try {
      const res = await fetch(`${API_URL}/orders/${id}/watchers`, {
        credentials: "include",
      });
      if (!res.ok) return;
      const data = await res.json();
      setWatchers(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("fetchWatchers error:", e);
    } finally {
      setWatchersLoading(false);
    }
  };

  const startWatching = async () => {
    try {
      await fetch(`${API_URL}/orders/${id}/watchers`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}), // dodaje zalogowanego usera
      });
      await fetchWatchers();
    } catch (e) {
      console.error("startWatching error:", e);
    }
  };

  const stopWatching = async () => {
    if (!currentUser?.id) return;
    try {
      await fetch(`${API_URL}/orders/${id}/watchers/${currentUser.id}`, {
        method: "DELETE",
        credentials: "include",
      });
      await fetchWatchers();
    } catch (e) {
      console.error("stopWatching error:", e);
    }
  };

  const addWatcherById = async (userId) => {
    try {
      await fetch(`${API_URL}/orders/${id}/watchers`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: Number(userId) }),
      });
      await fetchWatchers();
    } catch (e) {
      console.error("addWatcherById error:", e);
    }
  };

  // Kiedy pobierać watchers?
  useEffect(() => {
    fetchWatchers();
  }, [id]);

  // Funkcja pobierająca pełne dane zamówienia (z JOINami), zaktualizowana o opis_realizacji
  const fetchOrderDetails = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${id}`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd pobierania szczegółów zlecenia.");
      const data = await res.json();
      setOrder(data);
      setOpisRealizacji(data.opis_realizacji || "");
      // Ustawienie danych edycji na podstawie pobranych danych
      setEditData({
        tytul: data.tytul || "",
        opis_zlecenia: data.opis_zlecenia || "",
        waga: data.waga || "",
        rodzaj_zgloszenia: data.rodzaj_zgloszenia || "",
        obszar_id: data.obszar_id || "",
        klient_id: data.klient_id || "",
        osoba_wykonujaca_id: data.osoba_wykonujaca_id || "",
        status: data.status || "",
        deadline: data.deadline || "",
        stan_walidacji: data.stan_walidacji || false,
        osoba_walidujaca_id: data.osoba_walidujaca_id || "",
        nr_ref: data.nr_ref || "",
        osoba_wprowadzajaca_id: data.osoba_wprowadzajaca_id || "",
        stan_archiwizacji: data.stan_archiwizacji || false,
        komentarz_zamkniecia: data.komentarz_zamkniecia || "",
        osoba_zlecajaca: data.osoba_zlecajaca || "",
        nr_klienta: data.nr_klienta || "",
      });
      setAdvancedData({
        stan_walidacji: data.stan_walidacji || false,
        stan_archiwizacji: data.stan_archiwizacji || false,
        komentarz_zamkniecia: data.komentarz_zamkniecia || "",
      });
    } catch (err) {
      console.error(err);
      setError("Wystąpił błąd podczas pobierania danych zlecenia.");
    } finally {
      setLoading(false);
    }
  };

  // Funkcja do pobierania PDF
  const handleDownloadPDF = () => {
    setShowPdfOptions(true);
  };

  // Funkcja do pobierania raportu (PDF **lub** Excel)
  const handleGenerateReport = async (options) => {
    // zamknij modal niezależnie od formatu
    setShowPdfOptions(false);

    try {
      /* ---------------- EXCEL ---------------- */
      if (options.type === 'excel') {
        // korzystamy z istniejącego endpointu batch/excel dla pojedynczego id
        const response = await fetch(
          `${API_URL}/orders/batch/excel?ids=${order.id}`,
          { credentials: 'include' }
        );
        if (!response.ok) throw new Error('Błąd pobierania Excela');

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `Zlecenie_${order.nr_ref.replace('/', '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return; // nic więcej już nie robimy
      }

      /* ---------------- PDF ------------------ */
      if (options.type === 'pdf') {
        const { includeWorkTime, includeMaterials, includePrice } = options;
        const params = new URLSearchParams({
          includeWorkTime,
          includeMaterials,
          includePrice
        }).toString();

        const response = await fetch(
          `${API_URL}/orders/${order.id}/pdf?${params}`,
          { method: 'GET', credentials: 'include' }
        );
        if (!response.ok) throw new Error('Błąd pobierania PDF');

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = `Raport_Zlecenie_${order.nr_ref.replace('/', '-')}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return;
      }
    } catch (err) {
      console.error(err);
      alert('Wystąpił błąd podczas generowania raportu.');
    }
  };

  // Pobieranie danych zamówienia
  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchOrderDetails();

        /* --- suma materiałów --- */
        const mat = await fetch(
          `${API_URL}/orders/${id}/materials-summary`
        ).then(r => r.json());
        setMaterialSum(Number(mat.total_material_price || 0));

        /* --- suma godzin --- */
        const wt = await fetch(
          `${API_URL}/orders/${id}/worktime`,
          { credentials: 'include' }
        ).then(r => r.json());
        setTotalHours(Number(wt.totalHours || 0));
        setWorkTimeSummary(wt.summary || {});

        /* --- lista materiałów --- */
        const mats = await fetch(
          `${API_URL}/materials/${id}`,
          { credentials: 'include' }
        ).then(r => r.json());

        setMaterials(mats);
        setMaterialsLoading(false);

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  // Pobieranie opcji dla dropdownów – obszary i klienci, gdy edycja jest aktywna
  useEffect(() => {
    if (isEditing) {
      const fetchDropdowns = async () => {
        try {
          const resAreas = await fetch(`${API_URL}/orders/areas`, {
            credentials: "include",
          });
          const areasData = await resAreas.json();
          setAreas(areasData);
          const resClients = await fetch(`${API_URL}/orders/clients`, {
            credentials: "include",
          });
          const clientsData = await resClients.json();
          setClients(clientsData);
        } catch (err) {
          console.error(err);
        }
      };
      fetchDropdowns();
    }
  }, [isEditing]);

  // Pobieranie listy pracowników (także do wyboru walidatora)
  useEffect(() => {
    const fetchAllWorkers = async () => {
      try {
        const res = await fetch(`${API_URL}/orders/workers`, {
          credentials: "include",
        });
        if (!res.ok) throw new Error("Błąd pobierania wykonawców.");
        const data = await res.json();
        setWorkers(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchAllWorkers();
  }, []);

  const getPriorityStyle = (priority) => {
    switch (priority) {
      case "Bardzo Niski":
        return { color: "#004aad" };
      case "Niski":
        return { color: "#38b6ff" };
      case "Neutralny":
        return { color: "#bbd1f9" };
      case "Wysoki":
        return { color: "#ff914d" };
      case "Krytyczny":
        return { color: "#ff3131" };
      default:
        return {};
    }
  };

  // Funkcja sprawdzająca uprawnienia do edycji pól
  const canEditField = (field) => {
    if (!order || !currentUser) return false;

    // Admin może edytować wszystkie pola
    if (currentUser.role === "Admin") {
      return true;
    }

    // Moderator może edytować większość pól, w tym status
    if (currentUser.role === "Moderator") {
      return [
        "tytul", "opis_zlecenia", "waga", "rodzaj_zgloszenia", "obszar_id",
        "klient_id", "osoba_wykonujaca_id", "deadline", "osoba_zlecajaca", "status", "nr_klienta"
      ].includes(field);
    }

    // Twórca zlecenia może edytować te same pola co Moderator ale bez statusu
    if (currentUser.id === order.osoba_wprowadzajaca_id) {
      return [
        "tytul", "opis_zlecenia", "waga", "rodzaj_zgloszenia", "obszar_id",
        "klient_id", "osoba_wykonujaca_id", "deadline", "osoba_zlecajaca", "nr_klienta"
      ].includes(field);
    }

    // Osoba przydzielona może edytować tylko osobę wykonującą
    if (currentUser.id === order.osoba_wykonujaca_id) {
      return field === "osoba_wykonujaca_id";
    }

    return false;
  };

  // Obsługa edycji
  const hasEditPermission = () => {
    if (!order || !currentUser) return false;
    if (currentUser.role === "Admin" || currentUser.role === "Moderator") return true;
    if (currentUser.id === order.osoba_wprowadzajaca_id || currentUser.id === order.osoba_wykonujaca_id) return true;
    return false;
  };

  const handleEditToggle = () => {
    if (hasEditPermission()) {
      setIsEditing(true);
    } else {
      alert("Brak uprawnień do edycji tego zlecenia");
    }
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAdvancedChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAdvancedData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const bigintFields = [
    'osoba_wykonujaca_id',
    'osoba_walidujaca_id',
    'obszar_id',
    'klient_id',
    'osoba_wprowadzajaca_id'
  ];

  const handleEditSubmit = async () => {
    try {
      const dataToSend = {};
      Object.keys(editData).forEach((key) => {
        if (bigintFields.includes(key)) {
          dataToSend[key] = editData[key] === '' || editData[key] === undefined || editData[key] === null
            ? null
            : Number(editData[key]);
        } else {
          dataToSend[key] = editData[key] === '' ? null : editData[key];
        }
      });

      // jeśli user zmienił status w edycji → oznacz jako EDYCJA
      if (dataToSend.status && dataToSend.status !== order.status) {
        dataToSend.statusChangeMode = "EDIT";
      }

      // Jeśli status to "Walidacja", otwórz modal i nie wysyłaj jeszcze żądania
      if (dataToSend.status === "Walidacja") {
        setShowValidationModal(true);
        setIsEditing(false);
        return;
      }

      // Wysyłanie żądania dla innych statusów
      const res = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(dataToSend),
      });
      if (!res.ok) throw new Error("Błąd zapisywania zmian.");
      await fetchOrderDetails();
      setIsEditing(false);
      alert("Zmiany zostały zapisane!");
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas zapisywania zmian: " + err.message);
    }
  };

  const handleEditCancel = () => {
    setIsEditing(false);
    setEditData({
      tytul: order.tytul || "",
      opis_zlecenia: order.opis_zlecenia || "",
      waga: order.waga || "",
      rodzaj_zgloszenia: order.rodzaj_zgloszenia || "",
      obszar_id: order.obszar_id || "",
      klient_id: order.klient_id || "",
      osoba_wykonujaca_id: order.osoba_wykonujaca_id || "",
      status: order.status || "",
      deadline: order.deadline || "",
      stan_walidacji: order.stan_walidacji || false,
      osoba_walidujaca_id: order.osoba_walidujaca_id || "",
      nr_ref: order.nr_ref || "",
      osoba_wprowadzajaca_id: order.osoba_wprowadzajaca_id || "",
      stan_archiwizacji: order.stan_archiwizacji || false,
      komentarz_zamkniecia: order.komentarz_zamkniecia || "",
      osoba_zlecajaca: order.osoba_zlecajaca || "",
      nr_klienta: order.nr_klienta || "",
    });
    setAdvancedData({
      stan_walidacji: order.stan_walidacji || false,
      stan_archiwizacji: order.stan_archiwizacji || false,
      komentarz_zamkniecia: order.komentarz_zamkniecia || "",
    });
  };

  const handleOpenAdvancedModal = () => {
    setShowAdvancedModal(true);
  };

  const handleAdvancedSubmit = () => {
    setShowAdvancedModal(false);
    // Dane z modalu "Zaawansowane" są przechowywane w advancedData i wysyłane przy zapisywaniu
  };

  const handleBuyClick = () => {
    setShowPurchaseFormModal(true);
  };

  const handlePurchaseSave = (newPurchase) => {
    setShowPurchaseFormModal(false);
    // Opcjonalnie: można dodać powiadomienie o sukcesie
  };

  // ETAP 1: Akceptacja zlecenia
  const handleAcceptOrder = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}/accept`, {
        method: "POST",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd akceptacji zlecenia.");
      await fetchOrderDetails();
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas akceptacji zlecenia: " + err.message);
    }
  };

  // ETAP 2: Rozpoczęcie realizacji – modal
  const handleStartOrder = () => {
    setShowStartModal(true);
  };

  const handleStartOrderConfirm = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}/start`, {
        method: "POST",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd rozpoczęcia realizacji zlecenia.");
      await fetchOrderDetails();
      setShowStartModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas rozpoczęcia realizacji zlecenia: " + err.message);
    }
  };

  // ETAP Pause: Wstrzymanie zlecenia – modal
  const handlePauseOrder = () => {
    setShowPauseModal(true);
  };

  const handlePauseOrderConfirm = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ status: "Wstrzymane", statusChangeMode: "BUTTON" }),
      });
      if (!res.ok) throw new Error("Błąd wstrzymywania zlecenia.");
      await fetchOrderDetails();
      setShowPauseModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas wstrzymywania zlecenia: " + err.message);
    }
  };

  // ETAP Restart: Dla "Wstrzymane" – zmiana statusu na "Realizowane"
  const handleRestartOrder = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ status: "Realizowane", statusChangeMode: "BUTTON" }),
      });
      if (!res.ok) throw new Error("Błąd przywracania realizacji zlecenia.");
      await fetchOrderDetails();
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas przywracania realizacji zlecenia: " + err.message);
    }
  };

  // ETAP Walidacja (ETAP 5): Otwieranie modalu walidacyjnego
  const handleValidationOrder = () => {
    setSelectedValidator(order.osoba_walidujaca_id || "");
    setShowValidationModal(true);
  };

  // Poprawiony handler dla "Oddaj do Walidacji" – weryfikacja wybrania walidatora i zaznaczenia checkboxu
  const handleValidationSubmit = async () => {
    if (!selectedValidator) {
      alert("Wybierz osobę walidującą.");
      return;
    }
    if (!readyForValidation) {
      alert("Musisz zaznaczyć, że zlecenie jest gotowe do walidacji.");
      return;
    }
    try {
      const dataToSend = {};
      Object.keys(editData).forEach((key) => {
        if (bigintFields.includes(key)) {
          dataToSend[key] = editData[key] === '' || editData[key] === undefined || editData[key] === null
            ? null
            : Number(editData[key]);
        } else {
          dataToSend[key] = editData[key] === '' ? null : editData[key];
        }
      });
      // Dodaj wymagane pola dla statusu "Walidacja"
      dataToSend.status = "Walidacja";
      dataToSend.osoba_walidujaca_id = Number(selectedValidator);
      dataToSend.stan_walidacji = true;

      dataToSend.statusChangeMode = "BUTTON";

      const res = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(dataToSend),
      });
      if (!res.ok) throw new Error("Błąd oddawania zlecenia do walidacji.");
      await fetchOrderDetails();
      setShowValidationModal(false);
      alert("Zlecenie zostało oddane do walidacji!");
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas oddawania zlecenia do walidacji: " + err.message);
    }
  };

  // ETAP 5: Otwieranie modali walidacyjnych dla osoby walidującej
  const handleOpenConfirmValidationModal = () => {
    setConfirmValidationChecked(false);
    setShowConfirmValidationModal(true);
  };

  const handleOpenRejectValidationModal = () => {
    setRejectValidationChecked(false);
    setShowRejectValidationModal(true);
  };

  const handleConfirmValidationSubmit = async () => {
    if (!confirmValidationChecked) {
      alert("Musisz potwierdzić, że zlecenie zostało wykonane i sprawdzone.");
      return;
    }
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}/confirmValidation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd potwierdzania walidacji.");
      await fetchOrderDetails();
      setShowConfirmValidationModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas potwierdzania walidacji: " + err.message);
    }
  };

  const handleRejectValidationSubmit = async () => {
    if (!rejectValidationChecked) {
      alert("Musisz zaznaczyć, że zlecenie nie przeszło walidacji.");
      return;
    }
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}/rejectValidation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd odrzucania walidacji.");
      await fetchOrderDetails();
      setShowRejectValidationModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas odrzucania walidacji: " + err.message);
    }
  };

  // ETAP 6: Otwarcie modalu zamknięcia zlecenia (tylko dla Admina, status "Zatwierdzone")
  const handleOpenCloseOrderModal = () => {
    setCloseOrderComment("");
    setShowCloseOrderModal(true);
  };

  const handleCloseOrderSubmit = async () => {
    if (closeOrderComment.length > 150) {
      alert("Komentarz może mieć maksymalnie 150 znaków.");
      return;
    }
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}/close`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          osoba_zamykajaca_id: currentUser.id,
          komentarz_zamkniecia: closeOrderComment
        }),
      });
      if (!res.ok) throw new Error("Błąd zamykania zlecenia.");
      await fetchOrderDetails();
      setShowCloseOrderModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas zamykania zlecenia: " + err.message);
    }
  };

  const handleMarkInvoicing = async () => {
    try {
      const res = await fetch(
        `${API_URL}/orders/${order.id}/invoice`,
        { method: "POST", credentials: "include" }
      );
      if (!res.ok) throw new Error("Błąd zmiany statusu na Fakturowanie.");
      await fetchOrderDetails();
    } catch (err) {
      console.error(err);
      alert("Nie udało się ustawić statusu Fakturowanie: " + err.message);
    }
  };

  // Funkcja obsługi usuwania zlecenia
  const handleDeleteClick = () => {
    if (currentUser.role !== "Admin") {
      setDeleteNotAllowedMessage("Brak uprawnień do usuwania zlecenia.");
      setTimeout(() => setDeleteNotAllowedMessage(""), 3000);
    } else {
      setShowDeleteConfirmModal(true);
    }
  };

  const deleteOrder = async () => {
    try {
      const res = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "DELETE",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: deletePassword }),
      });
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.error || "Błąd usuwania zlecenia.");
      }
      alert("Zlecenie zostało usunięte.");
      navigate("/zlecenia");
    } catch (err) {
      setDeleteError(err.message);
      setTimeout(() => setDeleteError(""), 3000);
    }
  };

  // Otwieranie OrderInfoModal z opcjonalną zakładką
  const handleOpenOrderInfoModal = (initialTab = 'time') => {
    setOrderInfoInitialTab(initialTab);
    setShowOrderInfoModal(true);
  };

  const handleCloseOrderInfoModal = () => {
    setShowOrderInfoModal(false);
  };

  // Nowa funkcja zapisująca opis realizacji
  const handleOpisRealizacjiSave = async () => {
    try {
      const response = await fetch(`${API_URL}/orders/${order.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ opis_realizacji: opisRealizacji }),
      });
      if (!response.ok) throw new Error("Błąd aktualizacji opisu realizacji.");
      await fetchOrderDetails();
      setShowOpisRealizacjiModal(false);
    } catch (err) {
      console.error(err);
      alert("Wystąpił błąd podczas aktualizacji opisu realizacji: " + err.message);
    }
  };

  if (loading) return <div>Ładowanie...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!order) return <div>Nie znaleziono zlecenia</div>;

  // Opcje walidatorów 
	const validatorOptions = workers.filter((worker) =>
	  ["Logistyk", "Manager", "Szef"].includes(worker.position)
	);

  return (
    <div className="order-details-page">
      {deleteNotAllowedMessage && (
        <div className="temp-notification">{deleteNotAllowedMessage}</div>
      )}
      <div className="order-details-container">
        {/* Lewa sekcja */}
        <div className="order-left-panel">
          <div className="order-header-row">
            <div className="order-number">
              {isEditing && canEditField("nr_ref") ? (
                <input
                  type="text"
                  name="nr_ref"
                  value={editData.nr_ref}
                  onChange={handleEditChange}
                  className="modern-edit-input order-number-input"
                />
              ) : (
                order.nr_ref
              )}
            </div>
            <div className="order-title">
              {isEditing && canEditField("tytul") ? (
                <input
                  type="text"
                  name="tytul"
                  value={editData.tytul}
                  onChange={handleEditChange}
                  className="modern-edit-input order-title-input"
                />
              ) : (
                order.tytul
              )}
            </div>
            <div className="order-priority-container">
              <span className="order-priority-label">PRIORYTET:</span>
              {isEditing && canEditField("waga") ? (
                <select
                  name="waga"
                  value={editData.waga}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="Bardzo Niski">Bardzo Niski</option>
                  <option value="Niski">Niski</option>
                  <option value="Neutralny">Neutralny</option>
                  <option value="Wysoki">Wysoki</option>
                  <option value="Krytyczny">Krytyczny</option>
                </select>
              ) : (
                <span className="order-priority" style={getPriorityStyle(order.waga)}>
                  {order.waga}
                </span>
              )}
            </div>
          </div>
          <div className="order-description-box">
            <h3 className="description-heading">Opis Zlecenia</h3>
            {isEditing && canEditField("opis_zlecenia") ? (
              <textarea
                name="opis_zlecenia"
                value={editData.opis_zlecenia}
                onChange={handleEditChange}
                className="modern-edit-textarea order-description-textarea"
              />
            ) : (
              <p className="order-description-text">{order.opis_zlecenia || "Brak opisu."}</p>
            )}
          </div>

          {/* >>> DODANE: Opis Realizacji – tylko podgląd (pomiędzy Opis Zlecenia a Komentarze) */}
          <div className="order-realization-box" style={{ marginTop: '1rem' }}>
            <h3 className="description-heading">Opis Realizacji</h3>
            {opisRealizacji && opisRealizacji.trim() ? (
              <textarea
                ref={opisRealizacjiRef}
                value={opisRealizacji}
                readOnly
                className="modern-edit-textarea order-description-textarea"
                aria-label="Opis Realizacji (podgląd)"
                style={{ width: '100%', minHeight: '64px', overflow: 'hidden', resize: 'none' }}
              />
            ) : (
              <p className="order-description-text">Brak opisu realizacji.</p>
            )}
          </div>
          {/* <<< KONIEC DODANE */}

          {/* Sekcja komentarzy */}
          <OrderCommentsSection orderId={order.id} currentUser={currentUser} />

          {/* Sekcja Czas Pracy – identyczna karta jak w OrderInfoModal */}
          <div className="work-time-section">
            <h3>Czas Pracy Pracowników dla Zlecenia {order.nr_ref}:</h3>

            {(!workTimeSummary || Object.keys(workTimeSummary).length === 0) ? (
              <p>Brak danych o czasie pracy.</p>
            ) : (
              <div className="summary-card">
                <div className="summary-row">
                  <span className="summary-label">Łącznie godzin:</span>
                  <span className="summary-badge">{totalHours} h</span>
                </div>

                <h4 className="summary-title">Podsumowanie czasu pracy</h4>
                <div className="summary-grid">
                  {Object.entries(workTimeSummary).map(([name, hours]) => (
                    <div key={name} className="summary-item">
                      <span className="summary-name">{name}</span>
                      <span className="summary-hours">{hours} h</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Sekcja Materiał */}
          <div className="materials-section" style={{ marginTop: '1.5rem' }}>
            <h3>Materiały&nbsp;dla&nbsp;Zlecenia&nbsp;{order.nr_ref}:</h3>

            {materialsLoading ? (
              <p>Ładowanie...</p>
            ) : materials.length === 0 ? (
              <p>Brak dodanych materiałów.</p>
            ) : (
              <div className="materials-container">
                {materials.map((m) => (
                  <div key={m.id} className="material-card">
                    <h4>{m.name}</h4>
                    <div className="material-details">
                      <p><strong>Nr ref:</strong> {m.nr_ref}</p>
                      <p><strong>Kategoria:</strong> {m.category}</p>
                      {m.manufacturer && <p><strong>Producent:</strong> {m.manufacturer}</p>}
                      {m.symbol && <p><strong>Symbol:</strong> {m.symbol}</p>}
                      {m.catalog_number && <p><strong>Numer katalogowy:</strong> {m.catalog_number}</p>}
                      {m.serial_number && <p><strong>Numer seryjny:</strong> {m.serial_number}</p>}
                      {m.mac_address && <p><strong>Adres MAC:</strong> {m.mac_address}</p>}
                      {m.designation && <p><strong>Oznaczenie:</strong> {m.designation}</p>}
                      <p><strong>Ilość:</strong> {m.quantity} {m.quantity_type === 'metry' ? 'm' : 'szt.'}</p>
                      <p><strong>Cena:</strong> {m.price} {m.currency}</p>
                      <p><strong>Pobrał:</strong> {m.first_name} {m.last_name}</p>
                      <p><strong>Data:</strong> {new Date(m.created_at).toLocaleString('pl-PL')}</p>
                      {m.additional_description && (
                        <p><strong>Dodatkowy opis:</strong> {m.additional_description}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>{/* koniec order-left-panel */}

        {/* Prawa sekcja – dodatkowe informacje */}
        <div className="order-right-panel">
          <div className="order-additional-info">
            <p><strong>Data zgłoszenia:</strong> {formatDate(order.data_zlecenia)}</p>
            <p>
              <strong>Zgłaszający:</strong>{" "}
              {isEditing && canEditField("osoba_wprowadzajaca_id") ? (
                <select
                  name="osoba_wprowadzajaca_id"
                  value={editData.osoba_wprowadzajaca_id}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="">-- Wybierz zgłaszającego --</option>
                  {workers.map((worker) => (
                    <option key={worker.id} value={worker.id}>
                      {worker.first_name} {worker.last_name}
                    </option>
                  ))}
                </select>
              ) : (
                order.first_name && order.last_name ? `${order.first_name} ${order.last_name}` : "-"
              )}
            </p>
            <p>
              <strong>Przydzielony:</strong>{" "}
              {isEditing && canEditField("osoba_wykonujaca_id") ? (
                <select
                  name="osoba_wykonujaca_id"
                  value={editData.osoba_wykonujaca_id}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="">-- Wybierz wykonawcę --</option>
                  {workers.map((worker) => (
                    <option key={worker.id} value={worker.id}>
                      {worker.first_name} {worker.last_name}
                    </option>
                  ))}
                </select>
              ) : (
                order.executor_first_name && order.executor_last_name
                  ? `${order.executor_first_name} ${order.executor_last_name}`
                  : "-"
              )}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              {isEditing && canEditField("status") ? (
                <select
                  name="status"
                  value={editData.status}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  {currentUser.role === "Admin" ? (
                    <>
                      <option value="Oczekujące">Oczekujące</option>
                      <option value="Przydzielone">Przydzielone</option>
                      <option value="Realizowane">Realizowane</option>
                      <option value="Wstrzymane">Wstrzymane</option>
                      <option value="Walidacja">Walidacja</option>
                      <option value="Zatwierdzone">Zatwierdzone</option>
                      <option value="Fakturowanie">Fakturowanie</option>
                      <option value="Zamknięte">Zamknięte</option>
                    </>
                  ) : currentUser.role === "Moderator" ? (
                    <>
                      <option value="Oczekujące">Oczekujące</option>
                      <option value="Przydzielone">Przydzielone</option>
                      <option value="Realizowane">Realizowane</option>
                      <option value="Wstrzymane">Wstrzymane</option>
                      <option value="Walidacja">Walidacja</option>
                    </>
                  ) : null}
                </select>
              ) : (
                getStatusGif(order.status) ? (
                  <img src={getStatusGif(order.status)} alt={order.status} className="status-gif" />
                ) : (
                  "-"
                )
              )}
            </p>
            <p>
              <strong>Termin Zakończenia:</strong>{" "}
              {isEditing && canEditField("deadline") ? (
                <input
                  type="date"
                  name="deadline"
                  value={editData.deadline}
                  onChange={handleEditChange}
                  className="modern-edit-input"
                  min={new Date().toISOString().split("T")[0]}
                />
              ) : (
                formatDate(order.deadline)
              )}
            </p>
            <p>
              <strong>Nadzór Materiału:</strong>{" "}
              {isEditing && canEditField("osoba_walidujaca_id") ? (
                <select
                  name="osoba_walidujaca_id"
                  value={editData.osoba_walidujaca_id}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="">-- Wybierz osobę do nadzóru Materiału --</option>
                  {workers.filter(worker => worker.role === "Moderator" || worker.role === "Admin").map((worker) => (
                    <option key={worker.id} value={worker.id}>
                      {worker.first_name} {worker.last_name}
                    </option>
                  ))}
                </select>
              ) : (
                order.walidujaca_first_name && order.walidujaca_last_name
                  ? `${order.walidujaca_first_name} ${order.walidujaca_last_name}`
                  : "-"
              )}
            </p>
            <p>
              <strong>Rodzaj zlecenia:</strong>{" "}
              {isEditing && canEditField("rodzaj_zgloszenia") ? (
                <select
                  name="rodzaj_zgloszenia"
                  value={editData.rodzaj_zgloszenia}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  {(currentUser.role === "Admin"
                    ? ["Usługa", "Przegląd A", "Wewnętrzne", "Przegląd Z", "Reklamacja", "Awaria"]
                    : ["Awaria", "Usługa", "Wewnętrzne", "Reklamacja"]
                  ).map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              ) : (
                mapOrderType(order.rodzaj_zgloszenia)
              )}
            </p>
            <p>
              <strong>Obszar:</strong>{" "}
              {isEditing && canEditField("obszar_id") ? (
                <select
                  name="obszar_id"
                  value={editData.obszar_id}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="">-- Wybierz obszar --</option>
                  {areas.map((area) => (
                    <option key={area.id} value={area.id}>
                      {area.name}
                    </option>
                  ))}
                </select>
              ) : (
                order.area_name || "-"
              )}
            </p>
            <p>
              <strong>Klient:</strong>{" "}
              {isEditing && canEditField("klient_id") ? (
                <select
                  name="klient_id"
                  value={editData.klient_id}
                  onChange={handleEditChange}
                  className="modern-edit-select"
                >
                  <option value="">-- Wybierz klienta --</option>
                  {clients.map((client) => (
                    <option key={client.id} value={client.id}>
                      {client.name}
                    </option>
                  ))}
                </select>
              ) : (
                order.client_name || "-"
              )}
            </p>
            <p>
              <strong>Nr Klienta:</strong>{" "}
              {isEditing && canEditField("nr_klienta") ? (
                <input
                  type="text"
                  name="nr_klienta"
                  value={editData.nr_klienta}
                  onChange={handleEditChange}
                  className="modern-edit-input"
                />
              ) : (
                order.nr_klienta || "-"
              )}
            </p>
            <p>
              <strong>Osoba Zlecająca:</strong>{" "}
              {isEditing && canEditField("osoba_zlecajaca") ? (
                <input
                  type="text"
                  name="osoba_zlecajaca"
                  value={editData.osoba_zlecajaca}
                  onChange={handleEditChange}
                  className="modern-edit-input"
                />
              ) : (
                order.osoba_zlecajaca || "-"
              )}
            </p>
            <p>
              <strong>Data Rozpoczęcia Prac:</strong>{" "}
              {order.data_przyjecia ? formatDate(order.data_przyjecia) : "-"}
            </p>
            <p>
              <span className="order-summary-label">
                Wycena&nbsp;Materiału:
              </span>{" "}
              {materialSum.toFixed(2)}&nbsp;zł
            </p>
            <p>
              <span className="order-summary-label">
                Liczba&nbsp;Godzin&nbsp;Pracowników:
              </span>{" "}
              {totalHours}
            </p>
            <p>
              <strong>Data Zakończenia Prac:</strong>{" "}
              {order.data_zakonczenia ? formatDate(order.data_zakonczenia) : "-"}
            </p>
            <p>
              <strong>Data Archiwizacji:</strong>{" "}
              {order.data_zamkniecia ? formatDate(order.data_zamkniecia) : "-"}
            </p>
          </div>

          <div className="order-actions-container">
            {/* Przycisk "Dodaj Opis Realizacji do Raportu" na górze */}
            {currentUser && (order?.osoba_wykonujaca_id === currentUser.id || ['Moderator', 'Admin'].includes(currentUser.role)) && (
              <button className="action-btn full-width" onClick={() => setShowOpisRealizacjiModal(true)}>
                Dodaj Opis Realizacji do Raportu
              </button>
            )}
            {/* Grid dla "Czas Pracy" i "Materiał" */}
            <div className="order-actions-top">
              <button className="action-btn" onClick={() => handleOpenOrderInfoModal('time')}>
                Czas Pracy
              </button>
              <button className="action-btn" onClick={() => handleOpenOrderInfoModal('material')}>
                Materiał
              </button>
            </div>
			{currentUser?.role === "Admin" && (
			  <button
				className="action-btn full-width"
				style={{ marginTop: "0.75rem" }}
				onClick={() => setShowWorkTimeReportModal(true)}
			  >
				Czas Pracy Raportu
			  </button>
			)}
            {/* Kontener dla pozostałych przycisków statusowych */}
            <div className="order-actions-status">
              {order.status === "Oczekujące" &&
                currentUser &&
                Number(order.osoba_wykonujaca_id) === Number(currentUser.id) && (
                  <button className="action-btn" onClick={handleAcceptOrder}>
                    Akceptuj Zlecenie
                  </button>
                )}
              {order.status === "Przydzielone" &&
                currentUser &&
                Number(order.osoba_wykonujaca_id) === Number(currentUser.id) && (
                  <button className="action-btn" onClick={handleStartOrder}>
                    Realizuj Zlecenie
                  </button>
                )}
              {order.status === "Realizowane" &&
                currentUser &&
                Number(order.osoba_wykonujaca_id) === Number(currentUser.id) && (
                  <>
                    <button className="action-btn" onClick={handlePauseOrder}>
                      Wstrzymaj Zlecenie
                    </button>
                    <button className="action-btn" onClick={handleValidationOrder}>
                      Oddaj do Walidacji
                    </button>
                  </>
                )}
              {order.status === "Wstrzymane" &&
                currentUser &&
                Number(order.osoba_wykonujaca_id) === Number(currentUser.id) && (
                  <>
                    <button className="action-btn" onClick={handleRestartOrder}>
                      Realizuj Ponownie
                    </button>
                    <button className="action-btn" onClick={handleValidationOrder}>
                      Oddaj do Walidacji
                    </button>
                  </>
                )}
              {order.status === "Walidacja" &&
                currentUser &&
                Number(order.osoba_walidujaca_id) === Number(currentUser.id) && (
                  <>
                    <button className="action-btn" onClick={handleOpenConfirmValidationModal}>
                      Potwierdź Walidację
                    </button>
                    <button className="action-btn" onClick={handleOpenRejectValidationModal}>
                      Odrzuć Walidację
                    </button>
                  </>
                )}
              {order.status === "Zatwierdzone" &&
                currentUser &&
                currentUser.role === "Admin" && (
                  <>
                    <button className="action-btn" onClick={handleMarkInvoicing}>
                      Do Fakturowania
                    </button>
                    <button className="action-btn" onClick={handleOpenCloseOrderModal}>
                      Zamknij Zlecenie
                    </button>
                  </>
                )}

              {order.status === "Fakturowanie" &&
                currentUser &&
                currentUser.role === "Admin" && (
                  <button className="action-btn" onClick={handleOpenCloseOrderModal}>
                    Zamknij Zlecenie
                  </button>
                )}
            </div>
          </div>

          {/* === PANEL: Obserwatorzy Zlecenia === */}
          <div className="order-watchers-box">
            <h3 className="watchers-title">Obserwatorzy Zlecenia</h3>

            <div className="watchers-actions">
              {!isWatching ? (
                <button className="action-btn" onClick={startWatching}>
                  Zacznij Obserwować
                </button>
              ) : (
                <button className="action-btn" onClick={stopWatching}>
                  Przestań Obserwować
                </button>
              )}

              <button
                className="action-btn"
                onClick={() => {
                  setSelectedWatcherId("");
                  setShowAddWatcherModal(true);
                }}
              >
                Oznacz Obserwującego
              </button>
            </div>

            {watchersLoading ? (
              <p style={{ margin: 0 }}>Ładowanie...</p>
            ) : (
              <ul className="watchers-list">
                {watchers.length === 0 ? (
                  <li className="watcher-empty">Brak obserwujących</li>
                ) : (
                  watchers.map((w) => (
                    <li
                      key={w.user_id}
                      className={`watcher-item ${Number(w.user_id) === Number(currentUser?.id) ? "me" : ""}`}
                    >
                      {w.first_name} {w.last_name}
                      {Number(w.user_id) === Number(currentUser?.id) ? " (Ty)" : ""}
                    </li>
                  ))
                )}
              </ul>
            )}
          </div>
        </div>
      </div>

      <ModernActionBar
        order={order}
        isEditing={isEditing}
        handleEditToggle={handleEditToggle}
        handleEditSubmit={handleEditSubmit}
        handleEditCancel={handleEditCancel}
        handleDeleteClick={handleDeleteClick}
        handleOpenOrderInfoModal={handleOpenOrderInfoModal}
        handleBuyClick={handleBuyClick}
        handleDownloadPDF={handleDownloadPDF}
        handleOpenAdvancedModal={handleOpenAdvancedModal}
        currentUser={currentUser}
        isWatching={isWatching}
        onFollowClick={startWatching}
      />

      {/* Modal rozpoczęcia realizacji (ETAP 2) */}
      {showStartModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Rozpocznij realizację zlecenia</h3>
            <p>
              Czy zapoznałeś się ze szczegółowymi informacjami zlecenia i jesteś gotowy przejść do realizacji tego zlecenia?
            </p>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={handleStartOrderConfirm}>
                Potwierdzam
              </button>
              <button className="btn-submit" onClick={() => setShowStartModal(false)}>
                Anuluj
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal wstrzymania zlecenia (ETAP Pause) */}
      {showPauseModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Wstrzymanie zlecenia</h3>
            <p>Czy na pewno chcesz wstrzymać pracę nad tym zleceniem?</p>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={handlePauseOrderConfirm}>
                Tak
              </button>
              <button className="btn-submit" onClick={() => setShowPauseModal(false)}>
                Nie
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal walidacyjny – Oddaj do Walidacji (ETAP 5) */}
      {showValidationModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Oddaj zlecenie do walidacji</h3>
            <p>Wybierz osobę walidującą (osobę, która ma sprawdzić zlecenie):</p>
            <select
              value={selectedValidator}
              onChange={(e) => setSelectedValidator(e.target.value)}
              className="modern-edit-select"
              style={{ marginBottom: "1rem" }}
            >
              <option value="">-- Wybierz walidatora --</option>
              {validatorOptions.map((validator) => (
                <option key={validator.id} value={validator.id}>
                  {validator.first_name} {validator.last_name} ({validator.position})
                </option>
              ))}
            </select>
            <div style={{ marginBottom: "1rem" }}>
              <input
                type="checkbox"
                id="readyForValidation"
                checked={readyForValidation}
                onChange={(e) => setReadyForValidation(e.target.checked)}
              />
              <label htmlFor="readyForValidation" style={{ marginLeft: "0.5rem" }}>
                Zlecenie gotowe do walidacji
              </label>
            </div>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowValidationModal(false)}>
                Anuluj
              </button>
              <button className="btn-submit" onClick={handleValidationSubmit}>
                Zapisz i Wyślij
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal potwierdzenia walidacji – (ETAP 5: Potwierdź Walidację) */}
      {showConfirmValidationModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Formularz Potwierdzenia Walidacji</h3>
            <div>
              <input
                type="checkbox"
                id="confirmValidation"
                checked={confirmValidationChecked}
                onChange={(e) => setConfirmValidationChecked(e.target.checked)}
              />
              <label htmlFor="confirmValidation" style={{ marginLeft: "0.5rem" }}>
                Zlecenie zostało wykonane i sprawdzone
              </label>
            </div>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowConfirmValidationModal(false)}>
                Anuluj
              </button>
              <button className="btn-submit" onClick={handleConfirmValidationSubmit}>
                Potwierdź
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal odrzucenia walidacji – (ETAP 5: Odrzuć Walidację) */}
      {showRejectValidationModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Formularz Odrzucenia Walidacji</h3>
            <div>
              <input
                type="checkbox"
                id="rejectValidation"
                checked={rejectValidationChecked}
                onChange={(e) => setRejectValidationChecked(e.target.checked)}
              />
              <label htmlFor="rejectValidation" style={{ marginLeft: "0.5rem" }}>
                Zlecenie nie przeszło walidacji i zostaje cofnięte do wykonującego
              </label>
            </div>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowRejectValidationModal(false)}>
                Anuluj
              </button>
              <button className="btn-submit" onClick={handleRejectValidationSubmit}>
                Odrzuć Walidację
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal zamknięcia zlecenia (ETAP 6) */}
      {showCloseOrderModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Zamknij i Zarchiwizuj Zlecenie</h3>
            <p>Wpisz komentarz (maks. 150 znaków):</p>
            <input
              type="text"
              maxLength="150"
              placeholder="Komentarz"
              value={closeOrderComment}
              onChange={(e) => setCloseOrderComment(e.target.value)}
              className="modern-edit-input"
            />
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowCloseOrderModal(false)}>
                Anuluj
              </button>
              <button className="btn-submit" onClick={handleCloseOrderSubmit}>
                Zamknij Zlecenie
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal usuwania zlecenia – pierwszy krok */}
      {showDeleteConfirmModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Usunięcie zlecenia</h3>
            <p>Czy jesteś pewien, że chcesz usunąć to zlecenie?</p>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowDeleteConfirmModal(false)}>
                Anuluj
              </button>
              <button
                className="btn-submit"
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setShowDeletePasswordModal(true);
                }}
              >
                TAK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal usuwania zlecenia – drugi krok (hasło) */}
      {showDeletePasswordModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Potwierdź usunięcie hasłem</h3>
            <p>Podaj hasło do swojego konta:</p>
            <input
              type="password"
              placeholder="Hasło"
              value={deletePassword}
              onChange={(e) => setDeletePassword(e.target.value)}
              className="modern-edit-input"
            />
            {deleteError && <p style={{ color: "red" }}>{deleteError}</p>}
            <div className="modal-buttons">
              <button
                className="btn-submit"
                onClick={() => {
                  setShowDeletePasswordModal(false);
                  setDeletePassword("");
                }}
              >
                Anuluj
              </button>
              <button className="btn-submit" onClick={deleteOrder}>
                Potwierdź usunięcie
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal "Zaawansowane" dla Admina */}
      {showAdvancedModal && currentUser.role === "Admin" && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Zaawansowane ustawienia</h3>
            <div style={{ marginBottom: "1.5rem" }}>
              <label>
                <input
                  type="checkbox"
                  name="stan_walidacji"
                  checked={advancedData.stan_walidacji}
                  onChange={handleAdvancedChange}
                />
                Stan Walidacji
              </label>
            </div>
            <div style={{ marginBottom: "1.5rem" }}>
              <label>
                <input
                  type="checkbox"
                  name="stan_archiwizacji"
                  checked={advancedData.stan_archiwizacji}
                  onChange={handleAdvancedChange}
                />
                Stan Archiwizacji
              </label>
            </div>
            <div style={{ marginBottom: "1.5rem" }}>
              <label>
                Komentarz Zamknięcia:
                <textarea
                  name="komentarz_zamkniecia"
                  value={advancedData.komentarz_zamkniecia}
                  onChange={handleAdvancedChange}
                  className="modern-edit-textarea"
                  rows="4"
                />
              </label>
            </div>
            <div className="modal-buttons">
              <button className="btn-submit" onClick={() => setShowAdvancedModal(false)}>
                Anuluj
              </button>
              <button className="btn-submit" onClick={handleAdvancedSubmit}>
                Zatwierdź
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Zamówienia */}
      {showPurchaseFormModal && (
        <PurchaseFormModal
          orderId={order.id}
          initialNrRef={order.nr_ref}
          onClose={() => setShowPurchaseFormModal(false)}
          onSave={handlePurchaseSave}
        />
      )}

      {/* Nowy modal OrderInfoModal */}
      {showOrderInfoModal && (
        <OrderInfoModal
          orderId={order.id}
          user={currentUser}
          initialTab={orderInfoInitialTab}
          onClose={handleCloseOrderInfoModal}
        />
      )}
	  
	  {/* Nowy modal WorkTimeReportModal  */}
	  {showWorkTimeReportModal && currentUser?.role === "Admin" && (
	    <WorkTimeReportModal
	  	  visible={showWorkTimeReportModal}
	 	  orderId={order.id}
		  onClose={() => setShowWorkTimeReportModal(false)}
	    />
	  )}

      {/* PdfOptionsModal */}
      {showPdfOptions && (
        <PdfOptionsModal
          visible={showPdfOptions}
          onClose={() => setShowPdfOptions(false)}
          onGenerate={handleGenerateReport}
        />
      )}

      {/* Nowy modal opisu realizacji */}
      {showOpisRealizacjiModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Informacje w tym oknie zostaną umieszczone w Raporcie PDF zlecenia.</h3>
            <textarea
              value={opisRealizacji}
              onChange={(e) => setOpisRealizacji(e.target.value)}
              rows="10"
              style={{ width: "100%" }}
            />
            <div className="modal-buttons">
              <button className="btn-submit" onClick={handleOpisRealizacjiSave}>
                Zapisz
              </button>
              <button className="btn-submit" onClick={() => setShowOpisRealizacjiModal(false)}>
                Anuluj
              </button>
            </div>
          </div>
        </div>
      )}

      {/* === MODAL: Oznacz Obserwującego === */}
      {showAddWatcherModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Oznacz obserwującego</h3>

            <select
              value={selectedWatcherId}
              onChange={(e) => setSelectedWatcherId(e.target.value)}
              style={{ width: "100%", padding: "10px", borderRadius: "8px" }}
            >
              <option value="">-- wybierz osobę --</option>
              {workers.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.first_name} {u.last_name}
                </option>
              ))}
            </select>

            <div className="modal-buttons" style={{ marginTop: 16 }}>
              <button
                className="btn-submit"
                disabled={!selectedWatcherId}
                onClick={async () => {
                  await addWatcherById(selectedWatcherId);
                  setShowAddWatcherModal(false);
                }}
              >
                Dodaj
              </button>

              <button className="btn-cancel" onClick={() => setShowAddWatcherModal(false)}>
                Anuluj
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default OrderDetailsPage;
